import { render, staticRenderFns } from "./OrderCreatorServiceGlobalPackage.vue?vue&type=template&id=2ecc8b2a&scoped=true&"
import script from "./OrderCreatorServiceGlobalPackage.vue?vue&type=script&lang=js&"
export * from "./OrderCreatorServiceGlobalPackage.vue?vue&type=script&lang=js&"
import style0 from "./OrderCreatorServiceGlobalPackage.vue?vue&type=style&index=0&id=2ecc8b2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecc8b2a",
  null
  
)

export default component.exports